// HugeIcons Pro, copied in by scripts/icons.mjs. Inlined so they inherit currentColor.
const RAW = import.meta.glob('./icons/*.svg', { query: '?raw', import: 'default', eager: true });

export function iconSvg(name) {
    return RAW[`./icons/${name}.svg`] ?? '';
}

/** Decorative by default (the parent button carries the label); pass `label` for a standalone icon. */
export function Icon({ name, label }) {
    const a = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': 'true' };
    return <span class="icon" {...a} dangerouslySetInnerHTML={{ __html: iconSvg(name) }} />;
}
